import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import GlobalLoader from "../../admin/shared/globalLoader";

const UserLayout = () => {
    const loaderState = useSelector((state) => state.globalLoader);




    return (
        <>
            {loaderState ? (
                <GlobalLoader />
            ) : (
                <div className="page">

                    <Outlet />
                </div>
            )}
        </>
    );
};
export default UserLayout;
